import { createFileRoute } from '@tanstack/react-router'
import { ReportShell } from '@/components/features/reports/ReportShell'

// `?view=map` deep-links By-Practice straight into the Map view — used by the
// dashboard card and the sidebar "Practice Map" shortcut (#794).
export const Route = createFileRoute('/_authenticated/reports/quarterly')({
  validateSearch: (search: Record<string, unknown>): { view?: 'map' } =>
    search.view === 'map' ? { view: 'map' } : {},
  component: QuarterlyReportRoute,
})

function QuarterlyReportRoute() {
  const { view } = Route.useSearch()
  return <ReportShell initialViewMode={view} />
}
